<template>
  <div>
    <!-- START JACKET FULL -->
    <div
      v-if="
        j_sizeArray[0] === undefined &&
        t_sizeArray[0] === undefined &&
        w_sizeArray[0] === undefined && 
        sk_sizeArray[0] === undefined
      "
      style="color: red; text-align: center; text-weight: bold; font-size: 20px"
    >
      {{ trad.NoData }}
    </div>

    <!-- <div v-if="loadingData" style="text-align: center">
      <p>Loading data...</p>
      <v-progress-linear indeterminate color="cyan"></v-progress-linear>
    </div> -->

    <div
      v-if="j_sizeArray[0] !== undefined && j_sizeArray[0] !== null"
      style="border-style: solid; border-color: #272443; border-width: 1px"
    >
      <!-- style="display: flex; justify-content: center; margin: 0 auto" -->
      <div>
        <p style="font-weight: bold; padding-left: 5px" @click="debugInfo()">
          {{ trad.JACKET }} {{ trad.Quantity }}:
          {{ j_qtyArray.reduce((sum, nr) => sum + Number(nr), 0) }}
          , {{ trad.Model }}:{{ getProductTitle(j_model) }}
        </p>
        <v-row>
          <v-col cols="2" class="mr-n2 ml-2 font-weight-bold">
            <p class="my-4">{{ trad.SIZE }}</p>
            <p class="my-2">{{ trad.Quantity }}</p>
            <p class="my-2">{{ trad.LENGTH }}</p>

            <!-- Nu trebuie sa apara SLEEVE LENGTH pentru modelele:BW01,BW01-M,BW01-CL -->
            <p
              v-show="!['BW01', 'BW01-M', 'BW01-CL'].includes(j_model)"
              class="my-3"
            >
              {{ trad.SLEEVELENGTH }}
            </p>

            <p class="my-n1">{{ trad.HALFWAIST }}</p>
          </v-col>

          <v-col cols="10">
            <v-slide-group v-model="model" class="pa-0" show-arrows dense>
              <v-slide-item v-for="(n, index) in j_sizeArray.length" :key="n">
                <!-- Nu trebuie sa apara SLEEVE LENGTH pentru modelele:BW01,BW01-M,BW01-CL -->
                <v-card
                  class="my-3"
                  :height="
                    !['BW01', 'BW01-M', 'BW01-CL'].includes(j_model) ? 170 : 140
                  "
                  :width="index == j_baseModel ? '95' : '52'"
                  color="#eeeeee"
                  elevation="1"
                >
                  <!-- START JACKET SIZE -->
                  <v-row class="mx-1 mt-1 mb-3" align="center" justify="center">
                    <div
                      :class="index == j_baseModel ? 'px-6' : 'px-2'"
                      style="
                        width: 85px;
                        text-align: center;
                        border-style: solid;
                        border-color: #272443;
                        border-width: 2px;
                      "
                      :style="
                        index == j_baseModel
                          ? 'background-color: white;'
                          : 'background-color: #d8dbbc;'
                      "
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ j_sizeArray[index] }}
                          </span>
                        </template>
                        <div
                          v-if="
                            j_model &&
                            j_model.startsWith('IGAD') &&
                            j_sizeArray[index] in sizeEquiv.jkt
                          "
                          align="center"
                          justify="center"
                        >
                          {{ sizeEquiv.jkt[j_sizeArray[index]][0] }}
                          <br />
                          {{ sizeEquiv.jkt[j_sizeArray[index]][1] }}
                          <br />
                          {{ sizeEquiv.jkt[j_sizeArray[index]][2] }}
                        </div>
                      </v-tooltip>
                    </div>
                  </v-row>
                  <!-- END JACKET SIZE -->

                  <!-- START JACKET QTY -->
                  <v-row class="ma-1" align="center" justify="center">
                    <div
                      style="
                        width: 85px;
                        text-align: center;
                        border-style: solid;
                        border-color: #272443;
                        border-width: 2px;
                      "
                      :style="
                        j_qtyArray[index] >= 0
                          ? 'background-color: white'
                          : 'background-color: #fdbdbd'
                      "
                    >
                      <input
                        v-model.number="j_qtyArray[index]"
                        @change="
                          setHistory();
                          serieChanged();
                        "
                        type="number"
                        min="0"
                        max="999"
                        :disabled="readOnly"
                        :style="
                          index == j_baseModel
                            ? 'text-align: center; width: 81px; padding-left: 20px;'
                            : 'text-align: right; width: 44px;'
                        "
                      />
                    </div>
                  </v-row>
                  <!-- END JACKET QTY -->

                  <!-- START JACKET LENGTH -->
                  <v-row class="ma-1" align="center" justify="center">
                    <div
                      v-if="index == j_baseModel"
                      style="
                        display: flex;
                        width: 85px;
                        border-style: solid;
                        border-color: #272443;
                        border-width: 2px;
                      "
                      :style="
                        j_lengthArray[index] >= j_lengthMin &&
                        j_lengthArray[index] <= j_lengthMax
                          ? 'background-color: white'
                          : 'background-color: #fdbdbd'
                      "
                    >
                      <div
                        style="
                          width: 41px;
                          border-right: 1px solid black;
                          text-align: center;
                          color: #999999;
                          background-color: #f2f2f0;
                        "
                      >
                        {{ j_lengthHint }}
                      </div>

                      <input
                        :value="j_lengthArray[index]"
                        @change="
                          updateLine(
                            j_lengthArray[index],
                            $event,
                            'j_lengthArray'
                          )
                        "
                        type="text"
                        :disabled="readOnly"
                        style="
                          width: 44px;
                          text-align: center;
                          padding-left: 4px;
                        "
                      />
                    </div>
                    <div v-else style="margin-top: 3px; color: #999999">
                      {{ j_lengthArray[index] }}
                    </div>
                  </v-row>
                  <!-- END JACKET LENGTH -->

                  <!-- START JACKET SLEEVE LENGTH -->
                  <!-- Nu trebuie sa apara SLEEVE LENGTH pentru modelele:BW01,BW01-M,BW01-CL -->
                  <v-row
                    v-show="!['BW01', 'BW01-M', 'BW01-CL'].includes(j_model)"
                    class="ma-1"
                    align="center"
                    justify="center"
                  >
                    <div
                      v-if="index == j_baseModel"
                      style="
                        display: flex;
                        width: 85px;
                        border-style: solid;
                        border-color: #272443;
                        border-width: 2px;
                      "
                      :style="
                        j_sleeveLenArray[index] >= j_sleeveLengthMin &&
                        j_sleeveLenArray[index] <= j_sleeveLengthMax
                          ? 'background-color: white'
                          : 'background-color: #fdbdbd'
                      "
                    >
                      <div
                        style="
                          width: 41px;
                          border-right: 1px solid black;
                          text-align: center;
                          color: #999999;
                          background-color: #f2f2f0;
                        "
                      >
                        {{ j_sleeveLenHint }}
                      </div>

                      <input
                        :value="j_sleeveLenArray[index]"
                        @change="
                          updateLine(
                            j_sleeveLenArray[index],
                            $event,
                            'j_sleeveLenArray'
                          )
                        "
                        type="text"
                        :disabled="readOnly"
                        style="
                          width: 44px;
                          text-align: center;
                          padding-left: 4px;
                        "
                      />
                    </div>
                    <div v-else style="margin-top: 3px; color: #999999">
                      {{ j_sleeveLenArray[index] }}
                    </div>
                  </v-row>
                  <!-- END JACKET SLEEVE LENGTH -->

                  <!-- START JACKET HALF WAIST -->
                  <v-row class="ma-1" align="center" justify="center">
                    <div
                      v-if="index == j_baseModel"
                      style="
                        display: flex;
                        width: 85px;
                        border-style: solid;
                        border-color: #272443;
                        border-width: 2px;
                      "
                      :style="
                        j_halfWaistArray[index] < j_halfWaistHint - 4 ||
                        j_halfWaistArray[index] > j_halfWaistHint + 6
                          ? 'background-color: #fdbdbd'
                          : 'background-color: white'
                      "
                    >
                      <div
                        style="
                          width: 41px;
                          border-right: 1px solid black;
                          text-align: center;
                          color: #999999;
                          background-color: #f2f2f0;
                        "
                      >
                        {{ j_halfWaistHint }}
                      </div>

                      <input
                        :value="j_halfWaistArray[index]"
                        @change="
                          updateLine(
                            j_halfWaistArray[index],
                            $event,
                            'j_halfWaistArray'
                          )
                        "
                        type="text"
                        :disabled="readOnly"
                        style="
                          width: 44px;
                          text-align: center;
                          padding-left: 4px;
                        "
                      />
                    </div>
                    <div v-else style="margin-top: 3px; color: #999999">
                      {{ j_halfWaistArray[index] }}
                    </div>
                  </v-row>
                  <!-- END JACKET HALF WAIST -->
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- END JACKET FULL -->

    <!-- START TROUSERS FULL -->
    <div
      v-if="t_sizeArray[0] !== undefined && t_sizeArray[0] !== null"
      style="border-style: solid; border-color: #272443; border-width: 1px"
      class="my-1"
    >
      <p style="font-weight: bold; padding-left: 5px" @click="debugInfo()">
        {{ trad.TROUSERS }} {{ trad.Quantity }}:
        {{ t_qtyArray.reduce((sum, nr) => sum + Number(nr), 0) }}
        , {{ trad.Model }}:{{ getProductTitle(t_model) }}
      </p>

      <v-row>
        <v-col cols="2" class="mr-n2 ml-2 font-weight-bold">
          <p class="my-4">{{ trad.SIZE }}</p>
          <p class="my-2">{{ trad.Quantity }}</p>
          <p class="my-2">{{ trad.LENGTH }}</p>
          <p class="my-3">{{ trad.HALFWAIST }}</p>
          <p class="my-n1">{{ trad.HALFBOTTOM }}</p>
        </v-col>

        <v-col cols="10">
          <v-slide-group v-model="model" class="pa-0" show-arrows dense>
            <v-slide-item v-for="(n, index) in t_sizeArray.length" :key="n">
              <v-card
                class="my-3"
                height="170"
                :width="index == t_baseModel ? '95' : '52'"
                color="#eeeeee"
                elevation="1"
              >
                <!-- START TROUSERS SIZE -->
                <v-row class="mx-1 mt-1 mb-3" align="center" justify="center">
                  <div
                    :class="index == t_baseModel ? 'px-6' : 'px-2'"
                    style="
                      width: 85px;
                      text-align: center;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      index == t_baseModel
                        ? 'background-color: white;'
                        : 'background-color: #d8dbbc'
                    "
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ t_sizeArray[index] }}
                        </span>
                      </template>
                      <div
                        v-if="
                          t_model.startsWith('IPD') &&
                          t_sizeArray[index] in sizeEquiv.trs
                        "
                        align="center"
                        justify="center"
                      >
                        {{ sizeEquiv.trs[t_sizeArray[index]][0] }}
                        <br />
                        {{ sizeEquiv.trs[t_sizeArray[index]][1] }}
                        <br />
                        {{ sizeEquiv.trs[t_sizeArray[index]][2] }}
                      </div>
                    </v-tooltip>
                  </div>
                </v-row>
                <!-- END TROUSERS SIZE -->

                <!-- START TROUSERS QTY -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    style="
                      width: 85px;
                      text-align: center;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      t_qtyArray[index] >= 0
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <input
                      v-model.number="t_qtyArray[index]"
                      @change="
                        setHistory();
                        serieChanged();
                      "
                      type="number"
                      min="0"
                      max="999"
                      :disabled="readOnly"
                      :style="
                        index == t_baseModel
                          ? 'text-align: center; width: 81px; padding-left: 20px;'
                          : 'text-align: right; width: 44px;'
                      "
                    />
                  </div>
                </v-row>
                <!-- END TROUSERS QTY -->

                <!-- START TROUSERS LENGTH -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == t_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      t_lengthArray[index] >= t_lengthMin &&
                      t_lengthArray[index] <= t_lengthMax
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ t_lengthHint }}
                    </div>

                    <input
                      :value="t_lengthArray[index]"
                      @change="
                        updateLine(
                          t_lengthArray[index],
                          $event,
                          't_lengthArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ t_lengthArray[index] }}
                  </div>
                </v-row>
                <!-- END TROUSERS LENGTH -->

                <!-- START TROUSERS HALF WAIST -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == t_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      t_halfWaistArray[index] < t_halfWaistHint - 4 ||
                      t_halfWaistArray[index] > t_halfWaistHint + 6
                        ? 'background-color: #fdbdbd'
                        : 'background-color: white;'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ t_halfWaistHint }}
                    </div>

                    <input
                      :value="t_halfWaistArray[index]"
                      @change="
                        updateLine(
                          t_halfWaistArray[index],
                          $event,
                          't_halfWaistArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ t_halfWaistArray[index] }}
                  </div>
                </v-row>
                <!-- END TROUSERS HALF WAIST -->

                <!-- START TROUSERS HALF BOTTOM -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == t_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      t_halfBottomArray[index] >= t_halfBottomMin &&
                      t_halfBottomArray[index] <= t_halfBottomMax
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ t_halfBottomHint }}
                    </div>

                    <input
                      :value="t_halfBottomArray[index]"
                      @change="
                        updateLine(
                          t_halfBottomArray[index],
                          $event,
                          't_halfBottomArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ t_halfBottomArray[index] }}
                  </div>
                </v-row>
                <!-- END TROUSERS HALF BOTTOM -->
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </div>
    <!-- END TROUSERS FULL -->

    <!-- START WAISTCOAT FULL -->
    <div
      v-if="w_sizeArray[0] !== undefined && w_sizeArray[0] !== null"
      style="border-style: solid; border-color: #272443; border-width: 1px"
      class="my-1"
    >
      <p style="font-weight: bold; padding-left: 5px" @click="debugInfo()">
        {{ trad.WAISTCOAT }} {{ trad.Quantity }}:
        {{ w_qtyArray.reduce((sum, nr) => sum + Number(nr), 0) }}
        , {{ trad.Model }}:{{ getProductTitle(w_model) }}
      </p>

      <v-row>
        <v-col cols="2" class="mr-n2 ml-2 font-weight-bold">
          <p class="my-4">{{ trad.SIZE }}</p>
          <p class="my-2">{{ trad.Quantity }}</p>
          <p class="my-2">{{ trad.LENGTH }}</p>
          <p class="my-n1">{{ trad.HALFWAIST }}</p>
        </v-col>

        <v-col cols="10">
          <v-slide-group v-model="model" class="pa-0" show-arrows dense>
            <v-slide-item v-for="(n, index) in w_sizeArray.length" :key="n">
              <v-card
                class="my-3"
                height="140"
                :width="index == w_baseModel ? '95' : '52'"
                color="#eeeeee"
                elevation="1"
              >
                <!-- START WAISTCOAT SIZE -->
                <v-row class="mx-1 mt-1 mb-3" align="center" justify="center">
                  <div
                    :class="index == w_baseModel ? 'px-6' : 'px-2'"
                    style="
                      width: 85px;
                      text-align: center;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      index == w_baseModel
                        ? 'background-color: white'
                        : 'background-color: #d8dbbc'
                    "
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ w_sizeArray[index] }}
                        </span>
                      </template>
                      <div
                        v-if="
                          w_model.startsWith('IGD') &&
                          w_sizeArray[index] in sizeEquiv.wst
                        "
                        align="center"
                        justify="center"
                      >
                        {{ sizeEquiv.wst[w_sizeArray[index]][0] }}
                        <br />
                        {{ sizeEquiv.wst[w_sizeArray[index]][1] }}
                        <br />
                        {{ sizeEquiv.wst[w_sizeArray[index]][2] }}
                      </div>
                    </v-tooltip>
                  </div>
                </v-row>
                <!-- END WAISTCOAT SIZE -->

                <!-- START WAISTCOAT QTY -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    style="
                      width: 85px;
                      text-align: center;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      w_qtyArray[index] >= 0
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <input
                      v-model.number="w_qtyArray[index]"
                      @change="
                        setHistory();
                        serieChanged();
                      "
                      type="number"
                      min="0"
                      max="999"
                      :disabled="readOnly"
                      :style="
                        index == w_baseModel
                          ? 'text-align: center; width: 81px; padding-left: 20px;'
                          : 'text-align: right; width: 44px;'
                      "
                    />
                  </div>
                </v-row>
                <!-- END WAISTCOAT QTY -->

                <!-- START WAISTCOAT LENGTH -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == w_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      w_lengthArray[index] >= w_lengthMin &&
                      w_lengthArray[index] <= w_lengthMax
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ w_lengthHint }}
                    </div>

                    <input
                      :value="w_lengthArray[index]"
                      @change="
                        updateLine(
                          w_lengthArray[index],
                          $event,
                          'w_lengthArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ w_lengthArray[index] }}
                  </div>
                </v-row>
                <!-- END WAISTCOAT LENGTH -->

                <!-- START WAISTCOAT HALF WAIST -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == w_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      w_halfWaistArray[index] < w_halfWaistHint - 4 ||
                      w_halfWaistArray[index] > w_halfWaistHint + 6
                        ? 'background-color: #fdbdbd'
                        : 'background-color: white'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ w_halfWaistHint }}
                    </div>

                    <input
                      :value="w_halfWaistArray[index]"
                      @change="
                        updateLine(
                          w_halfWaistArray[index],
                          $event,
                          'w_halfWaistArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ w_halfWaistArray[index] }}
                  </div>
                </v-row>
                <!-- END WAISTCOAT HALF WAIST -->
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </div>
    <!-- END WAISTCOAT FULL -->

    <!-- START SKIRT FULL -->
    <div
      v-if="sk_sizeArray[0] !== undefined && sk_sizeArray[0] !== null"
      style="border-style: solid; border-color: #272443; border-width: 1px"
      class="my-1"
    >
      <p style="font-weight: bold; padding-left: 5px" @click="debugInfo()">
        {{ trad.SKIRT }} {{ trad.Quantity }}:
        {{ sk_qtyArray.reduce((sum, nr) => sum + Number(nr), 0) }}
        , {{ trad.Model }}:{{ sk_model }}
      </p>

      <v-row>
        <v-col cols="2" class="mr-n2 ml-2 font-weight-bold">
          <p class="my-4">{{ trad.SIZE }}</p>
          <p class="my-2">{{ trad.Quantity }}</p>
          <p class="my-2">{{ trad.LENGTH }}</p>
          <p class="my-3">{{ trad.HALFWAIST }}</p>
          <p class="my-n1">{{ trad.HALFBOTTOM }}</p>
        </v-col>

        <v-col cols="10">
          <v-slide-group v-model="model" class="pa-0" show-arrows dense>
            <v-slide-item v-for="(n, index) in sk_sizeArray.length" :key="n">
              <v-card
                class="my-3"
                height="170"
                :width="index == sk_baseModel ? '95' : '52'"
                color="#eeeeee"
                elevation="1"
              >
                <!-- START TROUSERS SIZE -->
                <v-row class="mx-1 mt-1 mb-3" align="center" justify="center">
                  <div
                    :class="index == sk_baseModel ? 'px-6' : 'px-2'"
                    style="
                      width: 85px;
                      text-align: center;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      index == sk_baseModel
                        ? 'background-color: white;'
                        : 'background-color: #d8dbbc'
                    "
                  >
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ sk_sizeArray[index] }}
                        </span>
                      </template>
                      <div
                        v-if="
                          sk_model.startsWith('IPD') &&
                          sk_sizeArray[index] in sizeEquiv.trs
                        "
                        align="center"
                        justify="center"
                      >
                        {{ sizeEquiv.trs[sk_sizeArray[index]][0] }}
                        <br />
                        {{ sizeEquiv.trs[sk_sizeArray[index]][1] }}
                        <br />
                        {{ sizeEquiv.trs[sk_sizeArray[index]][2] }}
                      </div>
                    </v-tooltip>
                  </div>
                </v-row>
                <!-- END TROUSERS SIZE -->

                <!-- START TROUSERS QTY -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    style="
                      width: 85px;
                      text-align: center;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      sk_qtyArray[index] >= 0
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <input
                      v-model.number="sk_qtyArray[index]"
                      @change="
                        setHistory();
                        serieChanged();
                      "
                      type="number"
                      min="0"
                      max="999"
                      :disabled="readOnly"
                      :style="
                        index == sk_baseModel
                          ? 'text-align: center; width: 81px; padding-left: 20px;'
                          : 'text-align: right; width: 44px;'
                      "
                    />
                  </div>
                </v-row>
                <!-- END TROUSERS QTY -->

                <!-- START TROUSERS LENGTH -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == sk_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      sk_lengthArray[index] >= sk_lengthMin &&
                      sk_lengthArray[index] <= sk_lengthMax
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ sk_lengthHint }}
                    </div>

                    <input
                      :value="sk_lengthArray[index]"
                      @change="
                        updateLine(
                          sk_lengthArray[index],
                          $event,
                          'sk_lengthArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ sk_lengthArray[index] }}
                  </div>
                </v-row>
                <!-- END TROUSERS LENGTH -->

                <!-- START TROUSERS HALF WAIST -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == sk_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      sk_halfWaistArray[index] < sk_halfWaistHint - 4 ||
                      sk_halfWaistArray[index] > sk_halfWaistHint + 6
                        ? 'background-color: #fdbdbd'
                        : 'background-color: white;'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ sk_halfWaistHint }}
                    </div>

                    <input
                      :value="sk_halfWaistArray[index]"
                      @change="
                        updateLine(
                          sk_halfWaistArray[index],
                          $event,
                          'sk_halfWaistArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ sk_halfWaistArray[index] }}
                  </div>
                </v-row>
                <!-- END TROUSERS HALF WAIST -->

                <!-- START TROUSERS HALF BOTTOM -->
                <v-row class="ma-1" align="center" justify="center">
                  <div
                    v-if="index == sk_baseModel"
                    style="
                      display: flex;
                      width: 85px;
                      border-style: solid;
                      border-color: #272443;
                      border-width: 2px;
                    "
                    :style="
                      sk_halfBottomArray[index] >= sk_halfBottomMin &&
                      sk_halfBottomArray[index] <= sk_halfBottomMax
                        ? 'background-color: white'
                        : 'background-color: #fdbdbd'
                    "
                  >
                    <div
                      style="
                        width: 41px;
                        border-right: 1px solid black;
                        text-align: center;
                        color: #999999;
                        background-color: #f2f2f0;
                      "
                    >
                      {{ sk_halfBottomHint }}
                    </div>

                    <input
                      :value="sk_halfBottomArray[index]"
                      @change="
                        updateLine(
                          sk_halfBottomArray[index],
                          $event,
                          'sk_halfBottomArray'
                        )
                      "
                      type="text"
                      :disabled="readOnly"
                      style="width: 44px; text-align: center; padding-left: 4px"
                    />
                  </div>
                  <div v-else style="margin-top: 3px; color: #999999">
                    {{ sk_halfBottomArray[index] }}
                  </div>
                </v-row>
                <!-- END TROUSERS HALF BOTTOM -->
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-col>
      </v-row>
    </div>
    <!-- END SKIRT FULL -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Serii",
  props: ["linkParams", "data"],

  data: () => ({
    // START DATA
    debug: false,
    // debugIP: "192.168.1.148",
    developer: "",

    layout: "default", // default | compact

    model: null,
    orderID: "",
    targetID: "", // teoretic folosit doar la SaveOrder (deprecated)
    language: "en",

    axiosTX: "",
    loadingData: false,
    readOnly: false,
    seriiIsValid: "",
    MSG: {}, // allData
    history: {},

    j_model: "",
    j_baseModel: "", // index
    j_sizeArray: [],
    j_qtyArray: [],
    j_lengthArray: [],
    j_lengthHint: "", // prima valoare, nealterabila
    j_lengthMin: 10,
    j_lengthMax: 140,
    j_sleeveLenArray: [],
    j_sleeveLenHint: "", // prima valoare, nealterabila
    j_sleeveLengthMin: 30,
    j_sleeveLengthMax: 82,
    j_halfWaistArray: [],
    j_halfWaistHint: "", // prima valoare, nealterabila , -4..+6

    t_model: "",
    t_baseModel: "", // index
    t_sizeArray: [],
    t_qtyArray: [],
    t_lengthArray: [],
    t_lengthHint: "", // prima valoare, nealterabila
    t_lengthMin: 61,
    t_lengthMax: 120,
    t_halfWaistArray: [],
    t_halfWaistHint: "", // prima valoare, nealterabila, -4..+6
    t_halfBottomArray: [],
    t_halfBottomHint: "", // prima valoare, nealterabila
    t_halfBottomAler: 0,
    t_halfBottomMin: 11,
    t_halfBottomMax: 35,

    w_model: "",
    w_baseModel: "", // index
    w_sizeArray: [],
    w_qtyArray: [],
    w_lengthArray: [],
    w_lengthHint: "", // prima valoare, nealterabila
    w_lengthMin: 10,
    w_lengthMax: 90,
    w_halfWaistArray: [],
    w_halfWaistHint: "", // prima valoare, nealterabila, -4..+6
    
    sk_model: "",
    sk_baseModel: "", // index
    sk_sizeArray: [],
    sk_qtyArray: [],
    sk_lengthArray: [],
    sk_lengthHint: "", // prima valoare, nealterabila
    sk_lengthMin: 10,
    sk_lengthMax: 120,
    sk_halfWaistArray: [],
    sk_halfWaistHint: "", // prima valoare, nealterabila, -4..+6
    sk_halfBottomArray: [],
    sk_halfBottomHint: "", // prima valoare, nealterabila
    sk_halfBottomAler: 0,
    sk_halfBottomMin: 1,
    sk_halfBottomMax: 65,

    trad: {
      JACKET: "JACKET",
      TROUSERS: "TROUSERS",
      WAISTCOAT: "WAISTCOAT",
      SKIRT: "SKIRT",
      Model: "Model",
      SIZE: "SIZE",
      Quantity: "Quantity",
      LENGTH: "LENGTH",
      SLEEVELENGTH: "SLEEVE LENGTH",
      HALFWAIST: "1/2 WAIST",
      HALFBOTTOM: "1/2 BOTTOM",
      NoData: "No data available",
    },

    popup: "ABC\nLine2",

    sizeEquiv: {
      jkt: {
        42: ["EU42", "FR44", "US-UK32R"],
        44: ["EU44", "FR46", "US-UK34R"],
        46: ["EU46", "FR48", "US-UK36R"],
        48: ["EU48", "FR50", "US-UK38R"],
        49: ["", "E49", "."],
        50: ["EU50", "FR52", "US-UK40R"],
        52: ["EU52", "FR54", "US-UK42R"],
        54: ["EU54", "FR56", "US-UK44R"],
        56: ["EU56", "FR58", "US-UK46R"],
        58: ["EU58", "FR60", "US-UK48R"],
        60: ["EU60", "FR62", "US-UK50R"],
        62: ["EU62", "FR64", "US-UK52R"],
        64: ["EU64", "FR66", "US-UK54R"],
        66: ["EU66", "FR68", "US-UK56R"],
        68: ["EU68", "FR70", "US-UK58R"],
        70: ["EU70", "FR72", "US-UK60R"],
      },

      trs: {
        42: ["EU42", "FR36", "US-UK26R"],
        44: ["EU44", "FR38", "US-UK28R"],
        46: ["EU46", "FR40", "US-UK30R"],
        48: ["EU48", "FR42", "US-UK32R"],
        50: ["EU50", "FR44", "US-UK34R"],
        52: ["EU52", "FR46", "US-UK36R"],
        54: ["EU54", "FR48", "US-UK38R"],
        56: ["EU56", "FR50", "US-UK40R"],
        58: ["EU58", "FR52", "US-UK42R"],
        60: ["EU60", "FR54", "US-UK44R"],
        62: ["EU62", "FR56", "US-UK46R"],
        64: ["EU64", "FR58", "US-UK48R"],
        66: ["EU66", "FR60", "US-UK50R"],
        68: ["EU68", "FR62", "US-UK52R"],
        70: ["EU70", "FR64", "US-UK54R"],
      },

      wst: {
        42: ["EU42", "FR44", "US-UK32R"],
        44: ["EU44", "FR46", "US-UK34R"],
        46: ["EU46", "FR48", "US-UK36R"],
        48: ["EU48", "FR50", "US-UK38R"],
        50: ["EU50", "FR52", "US-UK40R"],
        52: ["EU52", "FR54", "US-UK42R"],
        54: ["EU54", "FR56", "US-UK44R"],
        56: ["EU56", "FR58", "US-UK46R"],
        58: ["EU58", "FR60", "US-UK48R"],
        60: ["EU60", "FR62", "US-UK50R"],
        62: ["EU62", "FR64", "US-UK52R"],
        64: ["EU64", "FR66", "US-UK54R"],
        66: ["EU66", "FR68", "US-UK56R"],
        68: ["EU68", "FR70", "US-UK58R"],
        70: ["EU70", "FR72", "US-UK60R"],
      },

      sk: {
        42: ["EU42", "FR44", "US-UK32R"],
        44: ["EU44", "FR46", "US-UK34R"],
        46: ["EU46", "FR48", "US-UK36R"],
        48: ["EU48", "FR50", "US-UK38R"],
        50: ["EU50", "FR52", "US-UK40R"],
        52: ["EU52", "FR54", "US-UK42R"],
        54: ["EU54", "FR56", "US-UK44R"],
        56: ["EU56", "FR58", "US-UK46R"],
        58: ["EU58", "FR60", "US-UK48R"],
        60: ["EU60", "FR62", "US-UK50R"],
        62: ["EU62", "FR64", "US-UK52R"],
        64: ["EU64", "FR66", "US-UK54R"],
        66: ["EU66", "FR68", "US-UK56R"],
        68: ["EU68", "FR70", "US-UK58R"],
        70: ["EU70", "FR72", "US-UK60R"],
      },
    },

    // END DATA
  }),

  methods: {
    getProductTitle(product) {
      console.log("getProductTitle:", product, "layout:", this.layout);
      if(this.layout === 'default') {
        return product;
      }

      let arrayProducts = [
        "UGR",
        "GR",
        "GL",
        "PD11 18.6",
        "PR",
        "PD10U",
        "P40L",
        "GDI",
        "GIU",
        "GDIL",
      ];

      let model = "";

      for (const prod of arrayProducts) {
        if (product.startsWith(prod)) {
          model = product.slice(prod.length).trim();
          product = prod;
          break;
        }
      }
      
      switch (product) {
        case 'UGR':
          return 'Rimini (Big Size) ' + model;
        case 'GR':
          return 'Rimini (Regular) ' + model;
        case 'GL':
          return 'Rimini (Long Size) ' + model;
        case 'PD11 18.6':
          return 'Siena';
        case 'PR':
          return 'Rapallo (Regular)';
        case 'PD10U':
          return 'Rapallo (Big size)';
        case 'P40L':
          return 'Rapallo (Long size)';
        case 'GDIL':
          return 'Ravenna (Long size) ' + model;
        case 'GDI':
          return 'Ravenna ' + model;
        case 'GIU':
          return 'Ravenna (Big size) ' + model;
        default:
          return product;
      }
    },

    updateLine(oldItem, event, varName) {
      console.log(
        "oldItem:",
        oldItem,
        "eventTV:",
        event.target.value,
        "varname:",
        varName
      );

      let newItem = event.target.value;
      if (!isNaN(newItem)) {
        newItem = Number(newItem);
        oldItem = Number(oldItem);
        console.log("[updateLine]:", oldItem, newItem);
        console.log(`${varName}:`, JSON.stringify(this[varName]));
        this[varName] = this[varName].map((e) =>
          Number((e + newItem - oldItem).toFixed(1))
        );
      }

      this[varName] = this[varName].slice();
      this.setHistory();
    },

    debugInfo() {
      console.log(
        "%c[Debug Serii]",
        "color:lime;background-color:blue;font-size:14px"
      );

      console.log("linkParams:", this.linkParams);
      console.log("data:", this.data);

      // console.log("j_model:", this.j_model);
      // console.log("j_baseModel:", this.j_baseModel);
      // console.log("j_sizeArray:", this.j_sizeArray);
      // console.log("j_qtyArray:", this.j_qtyArray);
      // console.log("j_lengthArray:", this.j_lengthArray);
      // console.log("j_sleeveLenArray:", this.j_sleeveLenArray);
      // console.log("j_halfWaistArray:", this.j_halfWaistArray);

      // console.log("t_model:", this.t_model);
      // console.log("t_baseModel:", this.t_baseModel);
      // console.log("t_sizeArray:", this.t_sizeArray);
      // console.log("t_qtyArray:", this.t_qtyArray);
      // console.log("t_lengthArray:", this.t_lengthArray);
      // console.log("t_halfWaistArray:", this.t_halfWaistArray);
      // console.log("t_halfBottomArray:", this.t_halfBottomArray);

      // console.log("w_model:", this.w_model);
      // console.log("w_baseModel:", this.w_baseModel);
      // console.log("w_sizeArray:", this.w_sizeArray);
      // console.log("w_qtyArray:", this.w_qtyArray);
      // console.log("w_lengthArray:", this.w_lengthArray);
      // console.log("w_halfWaistArray:", this.w_halfWaistArray);

      this.checkSerii();
      this.makeMSG();

      console.log("MSG:", this.MSG);
    },

    makeMSG() {
      this.MSG = {
        from: "serieGet",
        seriiIsValid: this.seriiIsValid,
        orderID: this.orderID,
        language: this.language,
        targetid: this.linkParams?.targetid || "",

        j_model: this.j_model || "",
        j_baseModel: this.j_sizeArray[this.j_baseModel], // trimit direct valoarea (din index)
        j_baseModelIndex: this.j_baseModel, // pentru Load/Save Order
        j_sizeArray: this.j_sizeArray || [],
        j_qtyArray: this.j_qtyArray || [],
        j_lengthArray: this.j_lengthArray || [],
        j_lengthHint: this.j_lengthHint,
        j_sleeveLenArray: this.j_sleeveLenArray || [],
        j_sleeveLenHint: this.j_sleeveLenHint,
        j_halfWaistArray: this.j_halfWaistArray || [],
        j_halfWaistDif: Number(
          (
            this.j_halfWaistArray[this.j_baseModel] - this.j_halfWaistHint
          ).toFixed(1)
        ),
        j_halfWaistHint: this.j_halfWaistHint,

        t_model: this.t_model,
        t_baseModel: this.t_sizeArray[this.t_baseModel], // trimit direct valoarea (din index)
        t_baseModelIndex: this.t_baseModel, // pentru Load/Save Order
        t_sizeArray: this.t_sizeArray || [],
        t_qtyArray: this.t_qtyArray || [],
        t_lengthArray: this.t_lengthArray || [],
        t_lengthHint: this.t_lengthHint,
        t_halfWaistArray: this.t_halfWaistArray || [],
        t_halfWaistHint: this.t_halfWaistHint,
        t_halfWaistDif: Number(
          (
            this.t_halfWaistArray[this.t_baseModel] - this.t_halfWaistHint
          ).toFixed(1)
        ),
        t_halfBottomArray: this.t_halfBottomArray || [],
        t_halfBottomHint: this.t_halfBottomHint,

        w_model: this.w_model,
        w_baseModel: this.w_sizeArray[this.w_baseModel], // trimit direct valoarea (din index)
        w_baseModelIndex: this.w_baseModel, // pentru Load/Save Order
        w_sizeArray: this.w_sizeArray || [],
        w_qtyArray: this.w_qtyArray || [],
        w_lengthArray: this.w_lengthArray || [],
        w_lengthHint: this.w_lengthHint,
        w_halfWaistArray: this.w_halfWaistArray || [],
        w_halfWaistDif: Number(
          (
            this.w_halfWaistArray[this.w_baseModel] - this.w_halfWaistHint
          ).toFixed(1)
        ),
        w_halfWaistHint: this.w_halfWaistHint,

        sk_model: this.sk_model,
        sk_baseModel: this.sk_sizeArray[this.sk_baseModel], // trimit direct valoarea (din index)
        sk_baseModelIndex: this.sk_baseModel, // pentru Load/Save Order
        sk_sizeArray: this.sk_sizeArray || [],
        sk_qtyArray: this.sk_qtyArray || [],
        sk_lengthArray: this.sk_lengthArray || [],
        sk_lengthHint: this.sk_lengthHint,
        sk_halfWaistArray: this.sk_halfWaistArray || [],
        sk_halfWaistHint: this.sk_halfWaistHint,
        sk_halfWaistDif: Number(
          (
            this.sk_halfWaistArray[this.sk_baseModel] - this.sk_halfWaistHint
          ).toFixed(1)
        ),
        sk_halfBottomArray: this.sk_halfBottomArray || [],
        sk_halfBottomHint: this.sk_halfBottomHint,

      };
    },

    async translate() {
      console.log("\x1b[32m%s", "[Translate]");

      let payload = {
        language: this.language,
        words: Object.values(this.trad),
      };

      this.axiosTX = {
        method: "post",
        url: `https://node.formens.ro/translate`,
        data: payload,
      };

      let response = await this.axios(`translate [${this.language}]`);
      console.log(
        "\x1b[35m%s",
        `[Axios RX Translate [${this.language}]]:`,
        response.data
      );

      if (response.status == 200) {
        Object.entries(this.trad).forEach((item, index) => {
          this.trad[item[0]] = response.data.words[index];
        });
      } else {
        console.log("Translate AXIOS Error");
      }
    },

    async axios(origin) {
      console.log(
        "\x1b[35m%s",
        `[Axios TX ${origin}]:`,
        JSON.stringify(this.axiosTX)
      );

      // sample
      // this.axiosTX = {
      //   method: "post",
      //   url: "http://127.0.0.1:1880/axios",
      //   data: { ABC: 123 },
      //   headers: { "Content-Type": "application/json" },
      // };

      return await axios(this.axiosTX)
        .then((response) => {
          // console.log("RX:", response);
          return response;
        })
        .catch((error) => {
          // console.log("ERR:", error);
          return error;
        });
      // .then(function () {
      //   // console.log("always executed");

      // });
    },

    setHistory() {
      console.log("\x1b[32m%s", "[setHistory]");

      // START ADD JACKET HISTORY
      if (this.history.jacket === undefined) this.history.jacket = {};

      let jacket = this.history.jacket;
      jacket.model = this.j_model || ""; // sa fie acolo, ultimul model

      let index = this.j_baseModel;
      let jBaseModel = this.j_sizeArray[index]; // valoare efectiva
      jacket.baseModel = jBaseModel;

      jacket.size = this.history.jacket.size || {};
      this.j_sizeArray.forEach((e, index) => {
        jacket.size[e] = this.j_qtyArray[index];
      });

      // Corectie qty, daca am orice altceva in afara de numar
      this.j_qtyArray.forEach((item, index) => {
        if (!item || isNaN(item)) this.j_qtyArray[index] = 0;
      });

      jacket.length = this.j_lengthArray[index];
      jacket.sleeveLen = this.j_sleeveLenArray[index];
      jacket.halfWaist = this.j_halfWaistArray[index];

      this.history.jacket = jacket;
      // END ADD JACKET HISTORY

      // START ADD TROUSERS HISTORY
      if (this.history.trousers === undefined) this.history.trousers = {};

      let trousers = this.history.trousers;
      trousers.model = this.t_model; // sa fie acolo, ultimul model

      index = this.t_baseModel;
      let tBaseModel = this.t_sizeArray[index]; // valoare efectiva
      trousers.baseModel = tBaseModel;

      trousers.size = this.history.trousers.size || {};
      this.t_sizeArray.forEach((e, index) => {
        trousers.size[e] = this.t_qtyArray[index];
      });

      // Corectie qty, daca am orice altceva in afara de numar
      this.t_qtyArray.forEach((item, index) => {
        if (!item || isNaN(item)) this.t_qtyArray[index] = 0;
      });

      trousers.length = this.t_lengthArray[index];
      trousers.halfWaist = this.t_halfWaistArray[index];
      trousers.halfBottom = this.t_halfBottomArray[index];

      this.history.trousers = trousers;
      // END ADD TROUSERS HISTORY

      // START ADD WAISTCOAT HISTORY
      if (this.history.waistcoat === undefined) this.history.waistcoat = {};

      let waistcoat = this.history.waistcoat;
      waistcoat.model = this.w_model; // sa fie acolo, ultimul model

      index = this.w_baseModel;
      let wBaseModel = this.w_sizeArray[index]; // valoare efectiva
      waistcoat.baseModel = wBaseModel;

      waistcoat.size = this.history.waistcoat.size || {};
      this.w_sizeArray.forEach((e, index) => {
        waistcoat.size[e] = this.w_qtyArray[index];
      });

      // Corectie qty, daca am orice altceva in afara de numar
      this.w_qtyArray.forEach((item, index) => {
        if (!item || isNaN(item)) this.w_qtyArray[index] = 0;
      });

      waistcoat.length = this.w_lengthArray[index];
      waistcoat.halfWaist = this.w_halfWaistArray[index];

      this.history.waistcoat = waistcoat;
      // END ADD WAISTCOAT HISTORY

      // START ADD SKIRT HISTORY
      
      if (this.history.skirt === undefined) this.history.skirt = {};

      let skirt = this.history.skirt;
      skirt.model = this.sk_model; // sa fie acolo, ultimul model

      index = this.sk_baseModel;
      let skBaseModel = this.sk_sizeArray[index]; // valoare efectiva
      skirt.baseModel = skBaseModel;

      skirt.size = this.history.skirt.size || {};
      this.sk_sizeArray.forEach((e, index) => {
        skirt.size[e] = this.sk_qtyArray[index];
      });

      // Corectie qty, daca am orice altceva in afara de numar
      this.sk_qtyArray.forEach((item, index) => {
        if (!item || isNaN(item)) this.sk_qtyArray[index] = 0;
      });

      skirt.length = this.sk_lengthArray[index];
      skirt.halfWaist = this.sk_halfWaistArray[index];
      skirt.halfBottom = this.sk_halfBottomArray[index];

      this.history.skirt = skirt;

      // END SKIRT HISTORY
      // console.log("\x1b[32m%s", "history:", JSON.stringify(this.history, null, 2));
      // console.log("\x1b[32m%s", "[history]:", JSON.stringify(this.history));
      Object.keys(this.history).forEach((e) => {
        console.log(e, ":", this.history[e]);
      });
    },

    serieChanged() {
      // Send from Vue to B2B every updates/changes
      console.log("[Send [S] updates Vue => B2B]");
      this.checkSerii(); // STEP 1 : check data
      this.makeMSG(); // STEP 2 : prepare data
      this.MSG.from = "serieUpdate"; // schimb tip mesaj
      this.$emit("seriiEmit", this.MSG); // STEP 3 : send data to B2B
    },

    getHistory() {
      console.log("\x1b[32m%s", "[getHistory]:", this.history);

      // START GET JACKET HISTORY
      if (this.history.jacket !== undefined) {
        // restore quantity
        this.j_sizeArray.forEach((e, index) => {
          // console.log(e, index, this.history.jacket.size[e]);
          if (this.history.jacket.size[e] !== undefined) {
            // / fix nonNumeric
            if (isNaN(this.history.jacket.size[e]))
              this.history.jacket.size[e] = 0;

            this.j_qtyArray[index] = this.history.jacket.size[e];
          }
        });
        this.j_qtyArray = this.j_qtyArray.slice();

        // insert si "alterare" array pentru [length, sleeveLen si halfWaist]
        // doar daca baseModel nou este egal cu cel din history
        let index = this.j_baseModel;
        let jBaseModel = this.j_sizeArray[index];

        if (jBaseModel == this.history.jacket.baseModel) {
          let newItem = this.history.jacket.length;
          let oldItem = this.j_lengthArray[index];
          this.j_lengthArray = this.j_lengthArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.jacket.sleeveLen;
          oldItem = this.j_sleeveLenArray[index];
          this.j_sleeveLenArray = this.j_sleeveLenArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.jacket.halfWaist;
          oldItem = this.j_halfWaistArray[index];
          this.j_halfWaistArray = this.j_halfWaistArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );
        }
      }
      // END GET JACKET HISTORY

      // START GET TROUSERS HISTORY
      if (this.history.trousers !== undefined) {
        // restore quantity
        this.t_sizeArray.forEach((e, index) => {
          // console.log(e, index, this.history.trousers.size[e]);
          if (this.history.trousers.size[e] !== undefined) {
            // / fix nonNumeric
            if (isNaN(this.history.trousers.size[e]))
              this.history.trousers.size[e] = 0;

            this.t_qtyArray[index] = this.history.trousers.size[e];
          }
        });
        this.t_qtyArray = this.t_qtyArray.slice();

        // insert si "alterare" array pentru [length, halfWaist si halfBottom]
        // doar daca baseModel nou este egal cu cel din history
        let index = this.t_baseModel;
        let tBaseModel = this.t_sizeArray[index];

        if (tBaseModel == this.history.trousers.baseModel) {
          let newItem = this.history.trousers.length;
          let oldItem = this.t_lengthArray[index];
          this.t_lengthArray = this.t_lengthArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.trousers.halfWaist;
          oldItem = this.t_halfWaistArray[index];
          this.t_halfWaistArray = this.t_halfWaistArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.trousers.halfBottom;
          oldItem = this.t_halfBottomArray[index];
          this.t_halfBottomArray = this.t_halfBottomArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );
        }
      }
      // END GET TROUSERS HISTORY

      // START GET WAISTCOAT HISTORY
      if (this.history.waistcoat !== undefined) {
        // restore quantity
        this.w_sizeArray.forEach((e, index) => {
          // console.log(e, index, this.history.waistcoat.size[e]);
          if (this.history.waistcoat.size[e] !== undefined) {
            // / fix nonNumeric
            if (isNaN(this.history.waistcoat.size[e]))
              this.history.waistcoat.size[e] = 0;

            this.w_qtyArray[index] = this.history.waistcoat.size[e];
          }
        });
        this.w_qtyArray = this.w_qtyArray.slice();

        // insert si "alterare" array pentru [length si halfWaist]
        // doar daca baseModel nou este egal cu cel din history
        let index = this.w_baseModel;
        let tBaseModel = this.w_sizeArray[index];

        if (tBaseModel == this.history.waistcoat.baseModel) {
          let newItem = this.history.waistcoat.length;
          let oldItem = this.w_lengthArray[index];
          this.w_lengthArray = this.w_lengthArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.waistcoat.halfWaist;
          oldItem = this.w_halfWaistArray[index];
          this.w_halfWaistArray = this.w_halfWaistArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );
        }
      }
      // END GET WAISTCOAT HISTORY

      // START GET SKIRT HISTORY
      if (this.history.skirt !== undefined) {
        // restore quantity
        this.sk_sizeArray.forEach((e, index) => {
          // console.log(e, index, this.history.waistcoat.size[e]);
          if (this.history.skirt.size[e] !== undefined) {
            // / fix nonNumeric
            if (isNaN(this.history.skirt.size[e]))
              this.history.skirt.size[e] = 0;

            this.sk_qtyArray[index] = this.history.skirt.size[e];
          }
        });
        this.sk_qtyArray = this.sk_qtyArray.slice();

        // insert si "alterare" array pentru [length si halfWaist]
        // doar daca baseModel nou este egal cu cel din history
        let index = this.sk_baseModel;
        let skBaseModel = this.sk_sizeArray[index];

        if (skBaseModel == this.history.skirt.baseModel) {
          let newItem = this.history.skirt.length;
          let oldItem = this.sk_lengthArray[index];
          this.sk_lengthArray = this.sk_lengthArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.skirt.halfWaist;
          oldItem = this.sk_halfWaistArray[index];
          this.sk_halfWaistArray = this.sk_halfWaistArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );

          newItem = this.history.skirt.halfBottom;
          oldItem = this.sk_halfBottomArray[index];
          this.sk_halfBottomArray = this.sk_halfBottomArray.map((e) =>
            Number((e + newItem - oldItem).toFixed(1))
          );
        }
      }
      // END GET SKIRT HISTORY
    },

    async getSeriiData() {
      console.log("\x1b[32m%s", "[getSeriiData]");

      if (this.j_model && (this.j_model == "-" || this.j_model == "--"))
        this.j_model = ""; // corectie
      if (this.t_model && (this.t_model == "-" || this.t_model == "--"))
        this.t_model = ""; // corectie
      if (this.w_model && (this.w_model == "-" || this.w_model == "--"))
        this.w_model = ""; // corectie
      if (this.sk_model && (this.sk_model == "-" || this.sk_model == "--"))
        this.sk_model = ""; // corectie

      this.axiosTX = {
        method: "get",
        url: `https://b2b2.formens.ro/mtmoptions/serietabelmarimiobj?modelV=${this.j_model}&modelP=${this.t_model}&modelG=${this.w_model}&modelSk=${this.sk_model}`,
      };

      this.loadingData = true;
      const axiosRX = await this.axios("getSeriiData");
      this.loadingData = false;
      console.log("\x1b[35m%s", "[Axios RX getSeriiData]:", axiosRX.data);

      if (axiosRX.status == 200) {
        let data = []; // array cu toate datele primite din axios(getSeriiData), date ce vor fi filtrate
        const values = Object.values(axiosRX.data);
        values.forEach((e) => {
          if (e.enabled == true) data.push(e); // elimin enabled = false
        });

        console.log("[true only]:", data);

        if (this.j_model)
          data = data.filter(
            (e) => "V" in e && "TAILLE" in e.V && e.V.TAILLE !== 0
          ); // elimin junk-ul din Jacket (V)
        if (this.t_model)
          data = data.filter(
            (e) => "P" in e && "TAILLE" in e.P && e.P.TAILLE !== 0
          ); // elimin junk-ul din Trousers (P)
        if (this.w_model)
          data = data.filter(
            (e) => "G" in e && "TAILLE" in e.G && e.G.TAILLE !== 0
          ); // elimin junk-ul din Waistcoat (G)
        if (this.sk_model)
          data = data.filter(
            (e) => "Sk" in e && "TAILLE" in e.Sk && e.Sk.TAILLE !== 0
          ); // elimin junk-ul din skirt (G)

        console.log("[All Arrays(cleaned)]:", data);

        this.j_sizeArray = [];
        this.j_qtyArray = [];
        this.j_lengthArray = [];
        this.j_sleeveLenArray = [];
        this.j_halfWaistArray = [];

        this.t_sizeArray = [];
        this.t_qtyArray = [];
        this.t_lengthArray = [];
        this.t_halfWaistArray = [];
        this.t_halfBottomArray = [];

        this.w_sizeArray = [];
        this.w_qtyArray = [];
        this.w_lengthArray = [];
        this.w_halfWaistArray = [];
        
        this.sk_sizeArray = [];
        this.sk_qtyArray = [];
        this.sk_lengthArray = [];
        this.sk_halfWaistArray = [];
        this.sk_halfBottomArray = [];
        // doar daca am date  ; data = array cu toate datele primite (filtrate mai sus)
        if (data.length) {
          data.forEach((e) => {
            if (this.j_model) {
              this.j_sizeArray.push(e.V.TAILLE);
              this.j_qtyArray.push(0);
              this.j_lengthArray.push(e.V["H.MIL.DOS"]);
              this.j_sleeveLenArray.push(e.V["LONG.MAN"]);
              this.j_halfWaistArray.push(e.V["DEMI-TAILLE"]);
            }

            if (this.t_model) {
              this.t_sizeArray.push(e.P.TAILLE);
              this.t_qtyArray.push(0);
              this.t_lengthArray.push(e.P["ENTREJAMBE"]);
              this.t_halfWaistArray.push(e.P.CEINTURE);
              this.t_halfBottomArray.push(e.P.BAS);
            }

            if (this.w_model) {
              this.w_sizeArray.push(e.G.TAILLE);
              this.w_qtyArray.push(0);
              this.w_lengthArray.push(e.G["H.MIL.DOS"]);
              this.w_halfWaistArray.push(e.G["DEMI-TAILLE"]);
            }

            if (this.sk_model) {
              this.sk_sizeArray.push(e.Sk.TAILLE);
              this.sk_qtyArray.push(0);
              this.sk_lengthArray.push(e.Sk["L.COTE"]);
              this.sk_halfWaistArray.push(e.Sk.CEINTURE);
              this.sk_halfBottomArray.push(e.Sk.BAS);
            }

            // if (this.sk_model) {
            //   this.sk_sizeArray.push(e.Sk.TAILLE);
            //   this.sk_qtyArray.push(0);
            //   this.sk_lengthArray.push(e.Sk["ENTREJAMBE"]);
            //   this.sk_halfWaistArray.push(e.Sk.CEINTURE);
            //   this.sk_halfBottomArray.push(e.Sk.BAS);
            // }

          });

          let indexJ = this.j_sizeArray.findIndex(
            (e) => e == data[0].V["BASE-SIZE"]
          ); // atentie, nu merge cu indexOf deoarece cauti string in array de numere/string
          if (indexJ == -1 && this.j_model)
            // show error doar daca am date pentru Jacket
            console.log(
              "%c[CRITICAL - Jacket, nu am gasit BaseSize Valid]",
              "color:yellow;background-color:red;font-size:14px"
            );

          this.j_baseModel = indexJ; // active (editable column)
          // this.j_lengthHint = this.j_lengthArray[indexJ];
          this.j_lengthHint = "";
          this.j_sleeveLenHint = this.j_sleeveLenArray[indexJ];
          this.j_halfWaistHint = this.j_halfWaistArray[indexJ];

          let indexT = this.t_sizeArray.findIndex(
            (e) => e == data[0].P["BASE-SIZE"]
          ); // atentie, nu merge cu indexOf deoarece cauti string in array de numere/string
          if (indexT == -1 && this.t_model)
            // show error doar daca am date pentru Trousers
            console.log(
              "%c[CRITICAL - Trousers, nu am gasit BaseSize Valid]",
              "color:yellow;background-color:red;font-size:14px"
            );

          this.t_baseModel = indexT; // active (editable column)
          this.t_lengthHint = this.t_lengthArray[indexT];
          this.t_halfWaistHint = this.t_halfWaistArray[indexT];
          this.t_halfBottomHint = this.t_halfBottomArray[indexT];

          let indexW = this.w_sizeArray.findIndex(
            (e) => e == data[0].G["BASE-SIZE"]
          ); // atentie, nu merge cu indexOf deoarece cauti string in array de numere/string
          if (indexW == -1 && this.w_model)
            // show error doar daca am date pentru Waistcoat
            console.log(
              "%c[CRITICAL - Waistcoat, nu am gasit BaseSize Valid]",
              "color:yellow;background-color:red;font-size:14px"
            );

          this.w_baseModel = indexW; // active (editable column)
          this.w_lengthHint = this.w_lengthArray[indexW];
          this.w_halfWaistHint = this.w_halfWaistArray[indexW];
          
          let indexSk = this.sk_sizeArray.findIndex(
            (e) => e == data[0].Sk["BASE-SIZE"]
          ); // atentie, nu merge cu indexOf deoarece cauti string in array de numere/string
          if (indexSk == -1 && this.sk_model)
            // show error doar daca am date pentru Waistcoat
            console.log(
              "%c[CRITICAL - Skirt, nu am gasit BaseSize Valid]",
              "color:yellow;background-color:red;font-size:14px"
            );

          this.sk_baseModel = indexSk; // active (editable column)
          this.sk_lengthHint = this.sk_lengthArray[indexSk];
          this.sk_halfWaistHint = this.sk_halfWaistArray[indexSk];
          this.sk_halfBottomHint = this.sk_halfBottomArray[indexSk];
          // Corectie Jacket Length
          await this.corectieJKTLen();
        }
      } else {
        console.log("[getSeriiData AXIOS Error]");
      }
    },

    async corectieJKTLen() {
      console.log("\x1b[32m%s", "[corectieJKTLen]");
      // vechea versiune este mai jos, dar nu mai este cazul, deoarece la [j_baseModel], casuta unde editez Length La Jacket
      // o pun direct pe 0 , ca asa vrea big boss

      let oldLen = this.j_lengthArray[this.j_baseModel];
      let newLen = 0; // nu pot pune ?, ca apare NaN

      this.j_lengthArray = this.j_lengthArray.map((e) =>
        Number((e + newLen - oldLen).toFixed(1))
      );
      this.j_lengthArray = this.j_lengthArray.slice();

      this.j_lengthHint = ""; // actualizez Hint
    },

    async corectieJKTLenOLD() {
      console.log("\x1b[32m%s", "[corectieJKTLen]");

      let j_size = this.j_sizeArray[this.j_baseModel];

      this.axiosTX = {
        method: "get",
        url: `https://b2b2.formens.ro/mtmoptions/ajaxsacoumasuri?modelNo=${this.j_model}&size=${j_size}&alterations=&CodeAtitude=&CodeEpauleG=&CodeEpauleD=&CodePoitrine=&LungSpate=&LungManSt=&LungManDr=&Slit=&SlitDif=&Buton1=&Buton1Dif=`,
      };

      let response = await this.axios("corectieJKTLen");
      console.log("\x1b[35m%s", "[Axios RX corectieJKTLen]:", response.data);
      // Base G , Front FO => de la 75 la 82

      if (response.status == 200) {
        let oldLen = this.j_lengthArray[this.j_baseModel]; //Number(this.j_lengthHint);
        let newLen = Number(Number(response.data.HMILDOS.GAB).toFixed(1));

        // Manual, la jacket length pun default 0, asa vrea big boss
        newLen = 0;

        console.log("oldLen:", oldLen, "newLen:", newLen);

        if (newLen !== oldLen) {
          this.j_lengthArray = this.j_lengthArray.map((e) =>
            Number((e + newLen - oldLen).toFixed(1))
          );
          this.j_lengthArray = this.j_lengthArray.slice();

          // this.j_lengthHint = newLen; // actualizez Hint
          this.j_lengthHint = ""; // actualizez Hint
        }
      } else {
        console.log("corectieJKTLen AXIOS Error");
      }

      // https://b2b.formens.ro/mtmoptions/ajaxsacoumasuri?modelNo=G16&size=42&alterations=&CodeAtitude=400&CodeEpauleG=500&CodeEpauleD=600&CodePoitrine=800&LungSpate=&LungManSt=&LungManDr=&Slit=24&SlitDif=&Buton1=40&Buton1Dif=
    },

    checkSerii() {
      // console.log("\x1b[32m%s", "SERII CHECK");
      let valid = true;
      try {
        // JACKET
        if (this.j_sizeArray[0] !== undefined) {
          if (this.j_qtyArray.find((e) => e < 0) !== undefined) valid = false;

          let index = this.j_baseModel;

          if (
            this.j_lengthArray[index] < this.j_lengthMin ||
            this.j_lengthArray[index] > this.j_lengthMax
          )
            valid = false;

          if (
            this.j_sleeveLenArray[index] < this.j_sleeveLengthMin ||
            this.j_sleeveLenArray[index] > this.j_sleeveLengthMax
          )
            valid = false;

          if (
            this.j_halfWaistArray[index] < this.j_halfWaistHint - 4 ||
            this.j_halfWaistArray[index] > this.j_halfWaistHint + 6
          )
            valid = false;
        }

        // TROUSERS
        if (this.t_sizeArray[0] !== undefined) {
          if (this.t_qtyArray.find((e) => e < 0) !== undefined) valid = false;

          let index = this.t_baseModel;

          if (
            this.t_lengthArray[index] < this.t_lengthMin ||
            this.t_lengthArray[index] > this.t_lengthMax
          )
            valid = false;

          if (
            this.t_halfWaistArray[index] < this.t_halfWaistHint - 4 ||
            this.t_halfWaistArray[index] > this.t_halfWaistHint + 6
          )
            valid = false;

          if (
            this.t_halfBottomArray[index] < this.t_halfBottomMin ||
            this.t_halfBottomArray[index] > this.t_halfBottomMax
          )
            valid = false;
        }

        // WAISTCOAT
        if (this.w_sizeArray[0] !== undefined) {
          if (this.w_qtyArray.find((e) => e < 0) !== undefined) valid = false;

          let index = this.w_baseModel;

          if (
            this.w_lengthArray[index] < this.w_lengthMin ||
            this.w_lengthArray[index] > this.w_lengthMax
          )
            valid = false;

          if (
            this.w_halfWaistArray[index] < this.w_halfWaistHint - 4 ||
            this.w_halfWaistArray[index] > this.w_halfWaistHint + 6
          )
            valid = false;
        }

        // SKIRT
        if (this.sk_sizeArray[0] !== undefined) {
          if (this.sk_qtyArray.find((e) => e < 0) !== undefined) valid = false;

          let index = this.sk_baseModel;

          if (
            this.sk_lengthArray[index] < this.sk_lengthMin ||
            this.sk_lengthArray[index] > this.sk_lengthMax
          )
            valid = false;

          if (
            this.sk_halfWaistArray[index] < this.sk_halfWaistHint - 4 ||
            this.sk_halfWaistArray[index] > this.sk_halfWaistHint + 6
          )
            valid = false;

          if (
            this.sk_halfBottomArray[index] < this.sk_halfBottomMin ||
            this.sk_halfBottomArray[index] > this.sk_halfBottomMax
          )
            valid = false;
        }
      } catch (err) {
        console.log("Critical Erroe la Check Serii:", err);
        valid = false;
      }

      this.seriiIsValid = valid;
      console.log("\x1b[32m%s", "SERII CHECK:", this.seriiIsValid);
    },

    async saveOrder() {
      // Load gestionat de mine, Save gestionat de B2B PHP
      console.log("[serieSaveOrder]:", this.orderID);
      if (this.orderID === undefined) {
        if (this.orderID > 1634016748449) this.orderID = Date.now();
        console.log("\x1b[32m%s", "[NewTimeStampOrder]:", this.orderID);
      }

      this.makeMSG();

      let payload = {
        type: "saveSerii",
        orderid: this.orderID,
        data: this.MSG,
        targetID: this.targetID || "",
        timeStamp: Date.now(),
      };

      // Load gestionat de mine, Save gestionat de B2B PHP

      this.axiosTX = {
        method: "post",
        url: `https://ait.formens.ro/b2bFiles/`, // FMS23, local C:/B2B/Files/
        headers: {},
        data: payload,
      };

      let response = await this.axios(
        `Save [S${this.targetID}] orderID:${this.orderID}`
      );
      console.log(
        "\x1b[35m%s",
        `[Axios [S${this.targetID}] RX Save Order:${this.orderID}]:`,
        response
      );

      if (response.status == 200)
        console.log(`[S] Save OK Order: ${this.orderID}`);
      else console.log(`[S] Save FAIL Order: ${this.orderID}`);

      let dataToPostMesage = {
        from: "seriiGet",
        orderid: this.orderID,
        type: "SaveOrder",
        status: response.status == 200 ? true : false,
      };
      this.$emit("seriiEmit", dataToPostMesage);
    },

    async loadOrder() {
      // Load gestionat de mine, Save gestionat de B2B PHP
      // Declansat doar la [Created] (are si conditii)
      console.log(
        `%cserieLoadOrder[${this.linkParams?.targetid || ""}]:${this.orderID}`,
        "color:red; background-color:cyan; font-size:14px;"
      );

      this.makeMSG();

      if (this.orderID === undefined) return;

      let payload = {
        type: "loadSerii",
        orderID: this.orderID,
        targetId: this.linkParams?.targetid || "",
        debugMarker: "[S]LoadOrder",
      };

      this.axiosTX = {
        method: "post",
        url: `https://ait.formens.ro/b2bFiles`, // FMS23, local C:/B2B/Files/
        data: payload,
      };

      let response = await this.axios(
        `Load [S.${this.linkParams?.targetid || ""}] orderID:${this.orderID}`
      );
      console.log(
        "\x1b[35m%s",
        `[Axios [S.${this.linkParams?.targetid || ""}] RX Load Order:${
          this.orderID
        }]:`,
        response.data
      );

      if (response.data != "noFile") {
        this.j_model = response.data.j_model || "";
        this.j_baseModel = response.data.j_baseModelIndex; // ! index !
        this.j_sizeArray = response.data.j_sizeArray || [];
        this.j_qtyArray = response.data.j_qtyArray || [];
        this.j_lengthArray = response.data.j_lengthArray || [];
        // this.j_lengthHint = response.data.j_lengthHint;
        this.j_lengthHint = "";
        this.j_sleeveLenArray = response.data.j_sleeveLenArray || [];
        this.j_sleeveLenHint = response.data.j_sleeveLenHint;
        this.j_halfWaistArray = response.data.j_halfWaistArray || [];
        this.j_halfWaistHint = response.data.j_halfWaistHint;

        this.t_model = response.data.t_model || "";
        this.t_baseModel = response.data.t_baseModelIndex; // ! index !
        this.t_sizeArray = response.data.t_sizeArray || [];
        this.t_qtyArray = response.data.t_qtyArray || [];
        this.t_lengthArray = response.data.t_lengthArray || [];
        this.t_lengthHint = response.data.t_lengthHint;
        this.t_halfWaistArray = response.data.t_halfWaistArray || [];
        this.t_halfWaistHint = response.data.t_halfWaistHint;
        this.t_halfBottomArray = response.data.t_halfBottomArray || [];
        this.t_halfBottomHint = response.data.t_halfBottomHint;

        this.w_model = response.data.w_model || "";
        this.w_baseModel = response.data.w_baseModelIndex; // ! index !
        this.w_sizeArray = response.data.w_sizeArray || [];
        this.w_qtyArray = response.data.w_qtyArray || [];
        this.w_lengthArray = response.data.w_lengthArray || [];
        this.w_lengthHint = response.data.w_lengthHint;
        this.w_halfWaistArray = response.data.w_halfWaistArray || [];
        this.w_halfWaistHint = response.data.w_halfWaistHint;

        this.sk_model = response.data.sk_model || "";
        this.sk_baseModel = response.data.sk_baseModelIndex; // ! index !
        this.sk_sizeArray = response.data.sk_sizeArray || [];
        this.sk_qtyArray = response.data.sk_qtyArray || [];
        this.sk_lengthArray = response.data.sk_lengthArray || [];
        this.sk_lengthHint = response.data.sk_lengthHint;
        this.sk_halfWaistArray = response.data.sk_halfWaistArray || [];
        this.sk_halfWaistHint = response.data.sk_halfWaistHint;
        this.sk_halfBottomArray = response.data.sk_halfBottomArray || [];
        this.sk_halfBottomHint = response.data.sk_halfBottomHint;
        this.setHistory();
      } else console.log(`[S] Load FAIL Order: ${this.orderID}`);
    },
  },

  watch: {
    data: async function (allData) {
      console.log("WATCH data [S] TRIGGER", allData);

      // probabil mai primesc si alte date, folosite doar la <corporate>

      // B2B to Vue
      if (allData.type == "serieSend") {
        this.j_model = allData.data.j_model || "";
        this.t_model = allData.data.t_model || "";
        this.w_model = allData.data.w_model || "";
        this.sk_model = allData.data.sk_model || "";

        await this.getSeriiData();
        this.getHistory();
      }

      if (allData.type == "serieSave") {
        try {
          // deprecated, Load gestionat de mine, Save gestionat de B2B PHP
          this.targetID = allData.targetid || ""; // "0", "1" etc

          let orderID = allData.data || "";
          this.orderID = Number(orderID.replace("W", "")) - 10000;
          console.log(`[S${this.targetID}] orderID - 10K : ${this.orderID}`);
        } catch (err) {
          console.log("Critical Error la orderID - 10000");
        }

        this.saveOrder();
      }

      // Vue to B2B
      if (allData.type == "serieGet") {
        // this.targetID = allData.targetid || ""; // "0", "1" etc

        // STEP 1 : check data
        this.checkSerii();

        // STEP 2 : prepare data
        this.makeMSG();

        // STEP 3 : send data
        this.$emit("seriiEmit", this.MSG);
      }
    },
  },

  async mounted() {},

  async created() {
    console.log(
      `%c[SeriiB2B Created]`,
      "color:yellow;background-color:blue;font-size:14px"
    );

    if (this.linkParams.readonly == 1) this.readOnly = true;
    else this.readOnly = false;

    this.developer = process.env.NODE_ENV;
    if (process.env.NODE_ENV == "development") this.developer = true;
    else this.developer = false;

    if ("language" in this.linkParams) this.language = this.linkParams.language;
    else this.language = "en";

    if ("layout" in this.linkParams) this.layout = this.linkParams.layout;
    else this.layout = "default";

    await this.translate();

    this.orderID = this.linkParams.orderid;
    console.log("orderID:", this.orderID);
    if (this.orderID != "" && this.linkParams.corporate == "serii")
      this.loadOrder(); // load Order from NodeRed files
  },
};
</script>
